<div class="cc-tile-with-backBtn">
  <div class="title-backBtn" (click)="backKioskConfigurationGrid()"><span class="fas fa-long-arrow-alt-left"></span>
  </div>
  <h3>{{pageTitle}}</h3>
</div>

<div class="cc-single-tab cc-kiosk-config-wrapper">
  <form [formGroup]="kioskConfigurationForm" (ngSubmit)="saveConfiguration()">


    <div class="row row-gap">
      <div class="col-md-5">
        <!--Tab Display Options-->
        <section class="cc-section-wrapper">
          <div formGroupName="tabsGroup">
            <div>
              <h6 class="sub-heading">{{'_Kiosks_CheckIn_Display_Options_Title_Text_' | translate }}</h6>
            </div>

            <div class="checkbox">
              <label>
                <input id="signIn" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="showSignInTab" [disableControl]="!(isACLicenseEnabled$ | async)" />
                  {{'_Kiosks_SignInto_Lobby_Label_Text_' | translate }}
              </label>
            </div>

            <div class="checkbox" *ngIf="isACLicenseEnabled$ | async">
              <label>
                <input id="checkIn" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="showCheckInAppointmentTab" />
                  {{'_Kiosks_CheckIn_For_Appointment_Label_Text_' | translate }}
              </label>
            </div>

            <div class="checkbox" *ngIf="isACLicenseEnabled$ | async">
              <label>
                <input id="schedule" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="showBookScheduleTab" />
                  {{'_Kiosks_Schedule_Appointment_Label_Text_' | translate }}
              </label>
            </div>
            
            <div class="cc-validation"
              *ngIf="kioskConfigurationForm.get('tabsGroup')?.errors?.requireOneCheckboxToBeChecked">
              {{'_Kiosks_Select_CheckIn_Display_Option_Validation_Message_' | translate }}
            </div>

            <div class="checkbox mt-3" *ngIf="isACLicenseEnabled$ | async">
              <label>
                <input id="schedule" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="restrictSignInCheckInOutsideHours" />
                  {{'_Kiosk_Restrict_Sign_In_Check_In_Outside_Operating_Hours_' | translate }}
              </label>
            </div>

          </div>
        </section>        
      </div>
      <div class="col-md-7">
        <!--Option Input Fields-->
        <section class="cc-section-wrapper">
          <div formGroupName="inputFieldsGroup">
            <div class="row">
              <div class="col-md-12">
                <h6 class="sub-heading">{{'_Kiosks_Optional_Input_Fields_Title_Text_' | translate }}</h6>
              </div>
              <div class="offset-4 col-md-2 text-center">
                <label>{{'_General_Show_Text_' | translate }}</label>
              </div>
              <div class="col-md-2 text-center">
                <label>{{'_Kiosks_Optional_Input_Fields_Mandatory_Label_' | translate }}</label>
              </div>
            </div>
            <!-- Following Should move into a like of grid view -->
            <div *ngIf="isEnableAccountNumber" class="row checkbox">
              <div class="col-md-4">
                <label>
                  {{'_Account_Number_Field_Text_' | translate}}

                </label>
              </div>
              <div class="col-md-2 text-center">
                <input id="accountNumber" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="showAccountNumber" (change)="onlyFourInputOptionsAllowed()" />
              </div>
              <div class="col-md-2 text-center">
                <input id="mandatoryAccountNumberCheckbox" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="mandatoryAccountNumber" />
              </div>
            </div>
            <div class="row checkbox">
              <div class="col-md-4">
                <label>
                  {{'_General_Phone_Number_Column_Title_' | translate }}
                </label>
              </div>
              <div class="col-md-2 text-center">
                <input id="phoneNumber" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="showPhoneNumber" (change)="onlyFourInputOptionsAllowed()" />
              </div>
              <div class="col-md-2 text-center">
                <input id="mandatoryPhoneNumberCheckbox" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="mandatoryPhoneNumber" />
              </div>
            </div>
            <div class="row checkbox">
              <div class="col-md-4">
                <label>
                  {{'_General_Email_Address_Text_' | translate }}
                </label>
              </div>
              <div class="col-md-2 text-center">
                <input id="emailAddress" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="showEmailAddress" (change)="onlyFourInputOptionsAllowed()" />
              </div>
              <div class="col-md-2 text-center">
                <input id="mandatoryEmailAddressCheckbox" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="mandatoryEmailAddress" />
              </div>
            </div>
            <div class="row checkbox">
              <div class="col-md-4">
                <label>
                  {{'_General_DOB_Text_' | translate }}
                </label>
              </div>
              <div class="col-md-2 text-center">
                <input id="dateOfBirth" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="showDateOfBirth" (change)="onlyFourInputOptionsAllowed()" />
              </div>
              <div class="col-md-2 text-center">
                <input id="mandatoryDateOfBirthCheckbox" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="mandatoryDateOfBirth" />
              </div>
            </div>
            <div class="row checkbox" *ngIf="isEnableCustomField">
              <div class="col-md-4">
                <label>
                  {{'_Custom_Field_Text_' | translate }}

                </label>
              </div>
              <div class="col-md-2 text-center">
                <input id="CustomNotes" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="showCustomField1" (change)="onlyFourInputOptionsAllowed()" />
              </div>
              <div class="col-md-2 text-center">
                <input id="mandatorycustomNotesCheckbox" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                  formControlName="mandatoryCustomField1" />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>


    <div class="row row-gap">
      <div class="col-md-5">
        <!--Person Requested-->
        <section class="cc-section-wrapper">
          <div>
            <h6 class="sub-heading">{{'_Kiosks_Staff_Preference_Options_Title_Text_' | translate }}</h6>
          </div>
          <div class="row">
            <div class="col-md-10 radio">
              <div class="radio">
                <label>
                  <input id="personRequestedDontShow" class="" type="radio" kendoRadioButton
                    formControlName="showPersonRequested" value="false" (click)="setPersonRequested(false)" />
                  {{'_General_Dont_Show_Text_' | translate }}
                </label>
              </div>
              <div class="radio">
                <label>
                  <input id="personRequestedShow" class="" type="radio" kendoRadioButton
                    formControlName="showPersonRequested" value="true" (click)="setPersonRequested(true)" />
                    {{'_General_Show_Text_' | translate }}
                </label>
              </div>
              <div class="tab-indent">   
                <label class="checkbox">
                  <input id="includeMandatoryGroups" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                    formControlName="makePersonGroupRequestedMadatory" />
                    {{'_Kiosks_Require_Staff_Preference_Text_' | translate }}
                </label>       
                <label class="checkbox">
                  <input id="includeGroups" class="cc-filter-checkbox" type="checkbox" kendoCheckBox formControlName="showGroupRequested"
                    [(ngModel)]="canShowGroup" />
                  {{'_Kiosks_Include_Groups_Text_' | translate }}
                </label>      
                <div class="">
                  <div class=""><label>{{'_Kiosks_Default_Staff_Preference_Text_' | translate }}</label></div>
                  <div class="">
                    <select class="cc-select-dropdown form-control" id="selectPersonGroup" placeholder="'_General_Select_Text_' | translate" 
                      formControlName="defaultSelectedPersonOrGroup">
                      <option value="-1">{{'_General_Select_Text_' | translate }}</option>
                      <option *ngFor="let user of filterByGroup" [ngValue]="user">{{user.firstName}} {{user.lastName}}
                      </option>

                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> 
      </div>
      <div class="col-md-7">
        <!--Product / Service(s) Requested-->
        <section class="cc-section-wrapper">
          <div>
            <h6 class="sub-heading">{{'_Kiosks_Product/Service_Options_Title_Text_' | translate }}</h6>      
            <div class="row">
              <div class="col-md-12">
                <div class="radio">
                  <label>
                    <input id="productServicesDontShow" class="cc-filter-checkbox" type="radio" kendoRadioButton
                      formControlName="showServiceRequested" (click)="showServiceRequest(false)" value="false" />
                      {{'_General_Dont_Show_Text_' | translate }}
                  </label>
                </div>

                <div class="radio">
                  <label>
                    <input id="productServicesShow" class="cc-filter-checkbox" type="radio" kendoRadioButton
                      formControlName="showServiceRequested" (click)="showServiceRequest(true)" value="true" />
                      {{'_General_Show_Text_' | translate }}
                  </label>
                </div>

                <div class="row product-services-options">
                  <div class="col-md-6">
                    <div class="dropdown">
                      <label>{{'_Kiosks_Products/Services_Sort_ListBy_Text_' | translate }}</label>
                      <select class="cc-select-dropdown form-control" id="displayOrder" placeholder="Select"
                        formControlName="sortServiceListBy">
                        <option *ngFor="let order of productServiceOrder" [ngValue]="order.value">{{order.text}}
                        </option>
                      </select>
                    </div>
                    <div class="checkbox">
                      <label>
                        <input id="showCategories" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                          formControlName="showServiceRequestedCategorized" />
                          {{'_General_Show_Categories_Text_' | translate }}
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="dropdown">
                      <label> {{'_Kiosks_Font_Size_Text_' | translate }} </label>
                      <select class="cc-select-dropdown form-control" id="fontSize" placeholder="Select"
                        formControlName="fontSize">
                        <option *ngFor="let size of fontSizes" [ngValue]="size.value">{{size.text | translate}}</option>
                      </select>
                    </div>
                    <div class="checkbox">
                      <label>
                        <input id="productServiceMandatory" class="cc-filter-checkbox" type="checkbox" kendoCheckBox
                          formControlName="isProductServiceSelectionMandatory" />
                          {{'_Kiosks_Require_Product/Service_Selection_Text_' | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> 
      </div>
    </div>
    

    <div class="row row-gap">
      <div class="col-md-5">
        <!--Approximate Wait Time-->
        <section class="cc-section-wrapper wait-queue">
          <div>
            <h6 class="sub-heading">{{'_Kiosks_Wait_Time_And_Queue_Display_Title_Text_' | translate }}</h6>
            <div class="row">
              <div class="col-md-6">
              <h6 class="sub-heading-small">{{'_General_Home_Page_Text_' | translate }}</h6>
              <div class="checkbox">
                <label>
                  <input id="showWaitTimeHome" class="cc-filter-checkbox p-events" type="checkbox" kendoCheckBox
                    formControlName="showWaitTimeHome" (change)="setWaitTimeCalculation()" />
                  {{'_Show_Wait_Time_Text_' | translate }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input id="showVisitorsWaitingHome" class="cc-filter-checkbox p-events" type="checkbox" kendoCheckBox
                    formControlName="showVisitorsWaitingHome" (change)="setWaitTimeCalculation()" />
                  {{'_Show_Visitors_Waiting_Text_' | translate }}
                </label>
              </div>
              </div>
              <div class="col-md-6">
              <h6 class="sub-heading-small">{{'_Confirmation_Page_Text_' | translate }}</h6>
              <div class="checkbox">
                <label>
                  <input id="showWaitTimeConfirmation" class="cc-filter-checkbox p-events" type="checkbox" kendoCheckBox
                    formControlName="showWaitTimeConfirmation" (change)="setWaitTimeCalculation()" />
                  {{'_Show_Wait_Time_Text_' | translate }}
                </label>
              </div>
              <div class="checkbox">
                <label>
                  <input id="showQueuePositionConfirmation" class="cc-filter-checkbox p-events" type="checkbox" kendoCheckBox
                    formControlName="showQueuePositionConfirmation" (change)="setWaitTimeCalculation()" />
                  {{'_Show_Queue_Position_Text_' | translate }}
                </label>
              </div>
              </div>
              <div class="col-md-12">
                <div class="cc-validation"
                *ngIf="!this.kioskConfigurationForm.get('showWaitTimeHome')?.value && !this.kioskConfigurationForm.get('showVisitorsWaitingHome')?.value && !this.kioskConfigurationForm.get('showWaitTimeConfirmation')?.value && !this.kioskConfigurationForm.get('showQueuePositionConfirmation')?.value && this.kioskConfigurationForm.get('showWaitTime')?.value=='true'">
                {{'_Kiosk_Configuration_Approx_Wait_Time_Opt_Select_Text_' | translate}}</div>
              </div>
            </div>
            <h6 class="sub-heading mt-3">{{'_Kiosks_Wait_Time_Calculation_Text_' | translate }}</h6>
            <div class="row">
              <div class="col-md-12 radio">
                <label>
                  <input id="averageWaitTimeHrs" class="" type="radio" kendoRadioButton formControlName="waitOption"
                    value="hours" (click)="validateWaitOptionValue('hours')" />
                  {{'_Kiosks_Average_Wait_Time_For_Last_Text_' | translate }}<input class="form-control txtBox-small" type="text" formControlName="waitHoursValue" maxlength="3" app-filter
                  pattern="(^[0-9]*$)"> {{'_Kiosks_Wait_Time_Of_Hours_Text_' | translate }}
                </label>
                <div class="cc-validation" *ngIf="kioskConfigurationForm.get('waitHoursValue')?.errors?.required">
                  {{'_Kiosks_Wait_Time_Of_Hours_Validation_Failed_Text_' | translate }}
                </div>
                <!-- <div class="tab-indent averageWaitTimeHrs">
                  <div class="cc-inline">
                    <label>Past</label>
                    <input class="form-control" type="text" formControlName="waitHoursValue" maxlength="3" app-filter
                      pattern="(^[0-9]*$)">
                    <label># Of Hours</label>
                  </div>
                  <div class="cc-validation" *ngIf="kioskConfigurationForm.get('waitHoursValue')?.errors?.required">
                    Number of hours are required</div>
                </div> -->
              </div>

              <div class="col-md-12 radio">
                <label>
                  <input id="averageWaitTimeVisitors" class="" type="radio" kendoRadioButton
                    formControlName="waitOption" value="visitors" (click)="validateWaitOptionValue('visitors')" />
                  {{'_Kiosks_Wait_Time_Average_Wait_Time_For_Last_Text_' | translate }} <input class="form-control txtBox-small" type="text" formControlName="waitVisitorsValue" maxlength="3" app-filter
                  pattern="(^[0-9]*$)">{{'_Kiosks_Wait_Time_Of_Visitors_Served_Text_' | translate }}
                </label>
                <div class="cc-validation" *ngIf="kioskConfigurationForm.get('waitVisitorsValue')?.errors?.required">
                  {{'_Kiosks_Wait_Time_Of_Visitors_Served_Validation_Failed_Text_' | translate }}  
                </div>
                
                <!-- <div class="tab-indent averageWaitTimeVisitors">
                  <div class="cc-inline">
                    <label>Last</label>
                    <input class="form-control" type="text" formControlName="waitVisitorsValue" maxlength="3" app-filter
                      pattern="(^[0-9]*$)">
                    <label># Of Visitors Served</label>
                  </div>
                  <div class="cc-validation" *ngIf="kioskConfigurationForm.get('waitVisitorsValue')?.errors?.required">
                    Number of visitors are required</div>
                </div> -->
              </div>

              <div class="col-md-12 radio">
                <label>
                  <input id="displayExpectedWaitTime" class="" type="radio" kendoRadioButton
                    formControlName="waitOption" value="fullday" (click)="validateWaitOptionValue('fullday')" />
                    {{'_Kiosks_Average_Wait_Time_Radio_Button_Label_Text_' | translate }}
                </label>
              </div>
            </div>
             

             
            
          </div>
        </section>        

      </div>
      <div class="col-md-7">
        <!--Additional Settings-->
        <section class="cc-section-wrapper">
          <div>
            <h6 class="sub-heading">{{'_Kiosks_Additional_Settings_Title_Text_' | translate }}</h6>

            <div class="row">
              <div class="col-md-12 input">
                <div formGroupName="welcomeTextGroup">
                  <label for="welcomeText">{{'_Kiosks_Welcome_Message_Label_Text_' | translate }}</label>
                  <div class="cc-inline welcomeText">
                    <input id="welcomeText" class="form-control" type="text" formControlName="welcomeText"
                      maxlength="50" (change)="setWelcomeTextWhenTextChanged($event)">
                    <select class="cc-select-dropdown form-control" id="welcomeTextLanguage" placeholder="Select"
                      formControlName="welcomeTextDropDown">
                      <option *ngFor="let language of languageList" [ngValue]="language.id">{{language.text | translate}}</option>
                    </select>
                  </div>
                  <div class="cc-validation"
                    *ngIf="kioskConfigurationForm.get('welcomeTextGroup')?.errors?.welcomeTextRequired">{{'_Kiosks_Required_Welcome_Message_Validation_Text_' | translate }}</div>
                </div>
              </div>

              <div class="col-md-12 input">
                <div formGroupName="thankYouTextGroup">
                  <label for="thankYouText">{{'_Kiosks_Thank_You__Message_Label_Text_' | translate }}</label>
                  <div class="cc-inline thankYouText">
                    <input id="thankYouText" class="form-control" type="text" formControlName="thankYouText"
                      maxlength="120" (change)="setthankYouTextWhenTextChanged($event)">
                    <select class="cc-select-dropdown form-control" id="thankYouTextLanguage" placeholder="Select"
                      formControlName="thankYouTextDropDown">
                      <option *ngFor="let language of languageList" [ngValue]="language.id">{{language.text | translate}}</option>
                    </select>
                  </div>
                </div>
                <div class="cc-validation"
                  *ngIf="kioskConfigurationForm.get('thankYouTextGroup')?.errors?.thankYouTextRequired">{{'_Kiosks_Required_ThankYou_Message_Validation_Text_' | translate }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 input">
                <label for="refreshRate">{{'_Kiosks_Refresh_Rate_Label_Text_' | translate }}</label>
                <div class="cc-inline refresh-rate">
                  <input id="refreshRate" class="form-control" type="number" formControlName="refreshRateSeconds"
                    app-filter pattern="^$|^([1-9][0-9]{0,2})$">
                  <label>{{'_General_Seconds_Text_' | translate }}</label>
                </div>
                <div class="cc-validation" *ngIf="kioskConfigurationForm.get('refreshRateSeconds')?.errors?.required">
                  {{'_Kiosks_Refresh_Rate_Required_Validation_Message_Text_' | translate }}
                </div>
              </div>

              <div class="col-md-8 input">
                <label for="refreshRateHomeConf">{{'_Kiosks_Refresh_Rate_For_Home_Confirmation_Page_Label_Text_' | translate }}</label>
                <div class="cc-inline refresh-rate">
                  <input id="refreshRateHomeConf" class="form-control" type="number"
                    formControlName="homeConfirmationPageRefreshSeconds" app-filter pattern="^$|^([1-9][0-9]{0,2})$"
                    >
                  <label>{{'_General_Seconds_Text_' | translate }}</label>
                </div>
                <div class="cc-validation"
                  *ngIf="kioskConfigurationForm.get('homeConfirmationPageRefreshSeconds')?.errors?.required">
                  {{'_Kiosks_Refresh_Rate_For_Home_Confirmation_Page_Required_Validation_Message_Text_' | translate }}
                </div>
              </div>

              <div class="col-md-4 input">
                <label for="groupNotification">{{'_Kiosks_Default_Group_Notification_Label_Text_' | translate }}</label>
                <select class="cc-select-dropdown form-control" id="groupNotification" formControlName="defaultNotificationGroup" placeholder="Select">
                  <option value="0">{{'_General_Select_Text_' | translate }}</option>
                  <option *ngFor="let notificationGroup of notificationGroupList" [ngValue]="notificationGroup.id">{{notificationGroup.name}}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 checkbox">
                <label>
                  <input id="showSpanishSpeaker" type="checkbox" kendoCheckBox formControlName="showSpanishSpeaker" />
                  {{'_Kiosks_Show_Spanish_Speaker_Requested_Option_Label_Text_' | translate }}
                </label>
              </div>
              <div class="col-md-4 checkbox">
                <label>
                  <input id="showLanguageChange" type="checkbox" kendoCheckBox
                    formControlName="showChangeLanguageOption" />
                  {{'_Kiosks_Show_Language_Change_Option_Label_Text_' | translate }}
                </label>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Button Panel -->
    <div class="cc-btn-panel">
      <button type="button" class="btn btn-secondary" (click)="backToKioskGrid()">{{'_General_Button_Cancel_Text_' | translate }}</button>
      <button type="submit" class="btn btn-primary"
        [disabled]="!(mode=='add'? kioskConfigurationForm.valid : (kioskConfigurationForm.valid && kioskConfigurationForm.dirty)) || !isValidWaitTime">{{'_General_Button_Save_Text_' | translate }}</button>
    </div>
  </form>
</div>
